import { FC } from "react";

import { useAreaTitle } from "@ryde/redux";

interface INeighborAreasSettingsGroupTitleProps {
  areaId: number;
}

export const NeighborAreasSettingsGroupTitle: FC<
  INeighborAreasSettingsGroupTitleProps
> = ({ areaId }) => {
  const { title: areaLabel } = useAreaTitle(areaId);

  return (
    <div
      key={areaId}
      className="NeighborAreasSettings-GroupTitle display-mode"
      title={`${areaLabel} (ID:${areaId})`}
    >
      {areaLabel}
    </div>
  );
};
